import axios from '../../../lib/axios'
import { announcements } from '../../../lib/apiList'
import { Announcement, GetEmpFileParams } from '../types'

const sendAnnouncement = async (announcement: Announcement): Promise<any> => {
    const response = await axios.post(
        announcements.CREATE_ANNOUNCEMENT,
        announcement
    )
    return response.data
}

const searchAnnouncement = async ({
    currentPage,
    recordsPerPage,
}: GetEmpFileParams): Promise<any> => {
    const data = {
        pageSize: recordsPerPage ? recordsPerPage : 10,
        pageNumber: currentPage ? currentPage : 1,
    }
    const response = await axios.post(announcements.SEARCH_ANNOUCEMENT, data)
    return response.data
}

const deleteAnnouncement = async (id: string): Promise<any> => {
    const response = await axios.delete(announcements.DELETE_ANNOUNCEMENT, {
        data: { id },
    })
    return response.data
}
export { sendAnnouncement, searchAnnouncement, deleteAnnouncement }
